import DTReplaceItemThenSendMacroNode from '../Nodes/DTReplaceItemThenSendMacroNode/DTReplaceItemThenSendMacroNode';
import { getShowConfirmationPage } from '../../../selectors/tools';
import { useSelector } from 'react-redux';

const ReplaceItemThenSendMacro = () => {
  const showConfirmationPage = useSelector(getShowConfirmationPage);

  return (
    <DTReplaceItemThenSendMacroNode showConfirmation={showConfirmationPage} message={'The item has been replaced.'} />
  );
};

export default ReplaceItemThenSendMacro;
